import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { CACHE_EXPIRATION_TIME_REFERENCE_BOOK } from '@/features/constants';
import { ReferenceBook } from '@/features/organizations/types';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const consumptionCategoryKindsApi = createApi({
  reducerPath: 'consumptionCategoryKindsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/consumption-category-kinds`,
  }),
  keepUnusedDataFor: CACHE_EXPIRATION_TIME_REFERENCE_BOOK,
  endpoints: builder => {
    return {
      getConsumptionCategoryKinds: builder.query<ReferenceBook[], void>({
        query: () => ({
          url: ``,
        }),
      }),
    };
  },
});

export const { useGetConsumptionCategoryKindsQuery } =
  consumptionCategoryKindsApi;
